import { render, staticRenderFns } from "./VolumeCharts.vue?vue&type=template&id=6354d1a2&scoped=true"
import script from "./VolumeCharts.vue?vue&type=script&lang=js"
export * from "./VolumeCharts.vue?vue&type=script&lang=js"
import style0 from "./VolumeCharts.vue?vue&type=style&index=0&id=6354d1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6354d1a2",
  null
  
)

export default component.exports